import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Loading, EmptyState } from "@/components/shared";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";

export default function AuditLogs() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/audit-logs").then(({ data }) => setLogs(data)); }, []);
  if (!logs) return <Loading />;

  return (
    <div>
      <PageHeader title="操作履歴" subtitle="重要操作の監査ログ（削除不可）" />
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        {logs.length ? (
          <Table>
            <TableHeader><TableRow><TableHead>日時</TableHead><TableHead>操作者</TableHead><TableHead>操作内容</TableHead><TableHead>対象</TableHead><TableHead>IPアドレス</TableHead></TableRow></TableHeader>
            <TableBody>
              {logs.map((l) => (
                <TableRow key={l.id} data-testid={`log-${l.id}`}>
                  <TableCell className="text-xs text-slate-500 whitespace-nowrap">{(l.created_at || "").slice(0, 16).replace("T", " ")}</TableCell>
                  <TableCell className="text-sm">{l.user_name || "-"}</TableCell>
                  <TableCell className="text-sm font-medium text-slate-800">{l.action}</TableCell>
                  <TableCell className="text-xs text-slate-400">{l.target_type || "-"}</TableCell>
                  <TableCell className="text-xs text-slate-400">{l.ip || "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : <EmptyState title="操作履歴はありません" />}
      </div>
    </div>
  );
}
